<template>
  <div>
    <v-row>
      <v-col>
        <span class="text-tcdc-green sub-header1 bold text-uppercase">
         {{branchName}}
        </span>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <v-simple-table>
          <template v-slot:default>
            <thead>
              <tr>
                <template v-for="(item, index) of headers">
                  <th
                    :key="index.toString()"
                    class="text-left bold table-tcdc-header table-content-tcdc-color"
                  >{{ item[`text_${lang}`] }}</th>
                </template>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item, i) in membershipRate" :key="i">
                <td v-html="item[`name_${lang}`]"
                  class="table-tcdc-vertical-align-top  py-2 pl-0 ml-0 mr-12 table-content-tcdc-color vhtml"
                ></td>
                <td
                  class="table-tcdc-vertical-align-top  py-2 mx-12 table-content-tcdc-color"
                  style="font-family: Sarabun; font-size: 18px;"
                >{{ item[`dayPass_${lang}`] ? item[`dayPass_${lang}`]:'' }}</td>
                <td
                  class="table-tcdc-vertical-align-top  py-2 ml-12 mr-0 table-content-tcdc-color vhtml"
                  v-html="item[`annual_${lang}`]"
                ></td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
      </v-col>
    </v-row>
    <v-row>
      <v-col class="my-5">
        <p class="bold table-content-tcdc-color mb-3">Membership rate at other branches</p>
        <template v-for="(item, index) of tcdcBranches">
          <div :key="index.toString()" @click="memberRateHandler(item.branch_id)">
            <span class="text-uppercase text-tcdc-green bold cursor-pointer">
              {{item.branch_name}}
            </span>
          </div>
        </template>
      </v-col>
    </v-row>
  </div>
</template>

<script>
  import {mapState} from "vuex";

  export default {
    computed:{
      ...mapState({
        tcdcBranches : state=>{
          return state.Branch.branches;
        },
        branchName : state=>{
          return state.Branch.branch_name;
        },
        lang : state=>{
          return state.Branch.lang;
        },
        membershipRate: state => {
          return [
            ...state.ServiceMenu.membership_rate.map(rate=>({
              name_th : rate.detail_th,
              name_en : rate.detail_en,
              dayPass_th : rate.one_day_pass_th,
              dayPass_en : rate.one_day_pass_en,
              annual_th : rate.annual_fee_th,
              annual_en : rate.annual_fee_en
            }))
          ]
        }
      }),
    },
  methods: {
    memberRateHandler(branch_id) {
      this.getBranchNameById(branch_id);
      this.getMembershipRateByBranch(branch_id);
    },
    getMembershipRateByBranch(branch_id){
      this.branch_id = branch_id;
      this.$store.dispatch("ServiceMenu/getMembershipRateByBranch",{
        id : this.branch_id,
        lang : this.lang
      })
    },
    getBranchNameById(id){
      this.$store.dispatch("Branch/getBranchById",id);
    }
  },
  data: () => ({
    branch_id : 1,
    headers: [
      {
        text_th: "สมาชิก",
        text_en: "Membership",
        align: "start",
        value: "name"
      },
      { text_th: "บัตรรายวัน", text_en: "1 day pass", value: "dayPass", width: "100px" },
      { text_th: "ค่าธรรมเนียมรายปี", text_en: "Annual fee", value: "annual", width: "100px" }
    ],
    bodys: []
  })
};
</script>

<style lang="scss" scoped>
th,
td {
  min-width: 150px;
}
.table-tcdc-header:first-child {
  padding-left: 0px;
}
.table-content-tcdc-color {
  color: $tcdcGrey1;
}
.table-tcdc-vertical-align-top {
  vertical-align: top;
}
</style>
